import React from "react";

export default function CertificationSamples({ backgroundCol }) {
  return (
    <div className={backgroundCol ? backgroundCol : "bg-darkBlue"}>
      <div className="mainContainer flex flex-wrap lg:w-full 2xl:w-8/12  w-full justify-start lg:justify-evenly 2xl:justify-end mx-auto text-white py-10  max-w-6xl">
        <div className="left lg:w-5/12 flex-col lg:px-0 px-5 2xl:mr-10">
          <h2 className="text-4xl font-bold">
            <span className="text-orange font-secondary">Certification</span> Samples
          </h2>
          <p className="font-light font-opensans leading-loose pt-6">
            Certified translation services can be applied to a marriage or birth certificate, immigration documents, a reference letter, a diploma, or a lengthy legal document. It applies to diverse
            legal documents like contracts and patent applications as well as to a broader range of professional documentation like reference letters, scholarly papers, and business reports.
          </p>
        </div>
        <div className="right flex-col lg:flex-none justify-start pl-5 lg:pl-0 pt-6 lg:pt-0 w-10/12 sm:w-auto lg:w-5/12">
          <img src="https://tomedes.gumlet.io/frontend/images/services-new/certifications.webp" alt="" />
        </div>
      </div>
    </div>
  );
}
